"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageRequest = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_1 = require("@main/common");
var diveCrew_hero_data_1 = require("@voyage/crew/diveCrew_hero_data");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var voyageCarryableData_1 = require("@voyage/entities/voyageCarryableData");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageUiBuyStuff_data_1 = require("@voyage/ui/voyageUiBuyStuff_data");
var voyageTilemap_sidecar_1 = require("../tilemap/voyageTilemap-sidecar");
var voyageMessageCrewCarry_1 = require("./voyageMessageCrewCarry");
var voyageMessageCrewCarry_sidecar_1 = require("./voyageMessageCrewCarry-sidecar");
var voyageMessageCrewCreate_1 = require("./voyageMessageCrewCreate");
var voyageMessageCrewCreate_sidecar_1 = require("./voyageMessageCrewCreate-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var voyageMessageMoney_sidecar_1 = require("./voyageMessageMoney-sidecar");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.BuyRequest;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crewId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.buyType);
    messageWriter_sidecar_1.messageWriter.write8(m, d.itemType);
    messageWriter_sidecar_1.messageWriter.writeFloat(m, d.cost);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        crewId: messageWriter_sidecar_1.messageWriter.read32(m),
        buyType: messageWriter_sidecar_1.messageWriter.read8(m),
        itemType: messageWriter_sidecar_1.messageWriter.read8(m),
        cost: messageWriter_sidecar_1.messageWriter.readFloat(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        crewId: 123,
        buyType: voyageUiBuyStuff_data_1.EBuyType.item,
        itemType: voyageCarryableData_1.EVoyageCarryableType.Extinguisher,
        cost: 123.32,
    };
    messageWriter_sidecar_1.messageWriter.test('buy-request', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    // console.log('BUY!')
    if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
        // TODO: spend money
        // console.log('BUY!1')
        //let data = voyageUiBuyStuff_data.get(msg.)
        var status_1 = voyageGameStatus_sidecar_1.voyageGameStatus.get();
        if (msg.cost > status_1.money) {
            // Send error, not enough moneys
        }
        else {
            // console.log('BUY!2')
            if (msg.buyType === voyageUiBuyStuff_data_1.EBuyType.crew) {
                // console.log('BUY!3')
                var t = voyageTilemap_sidecar_1.voyageTilemap.getRandomFreeSystem('tele');
                if (!t) {
                    var cr = diveCrew_sidecar_1.diveCrew.findById(msg.crewId);
                    assert_sidecar_1.assert.notNil(cr);
                    diveCrew_sidecar_1.diveCrew.say(cr, 'No open teleporter!');
                }
                if (t) {
                    voyageMessageMoney_sidecar_1.voyageMessageMoney.sendMessageAndImmediatelyExecute({
                        money: status_1.money - msg.cost,
                    });
                    voyageMessageCrewCreate_sidecar_1.voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
                        crewId: common_1.createId(),
                        energy: 500,
                        i: t.i,
                        j: t.j,
                        method: voyageMessageCrewCreate_1.EVoyageCrewCreateMethod.Teleport,
                        team: 0,
                        type: diveCrew_1.EVoyageCrewType.Hero,
                        heroType: diveCrew_hero_data_1.EDiveHeroSubtype.None,
                        enemyType: '',
                        hitpoints: 100,
                        // name: rando
                    });
                }
            }
            if (msg.buyType === voyageUiBuyStuff_data_1.EBuyType.item) {
                // console.log('BUY!4')
                var t = voyageTilemap_sidecar_1.voyageTilemap.getRandomFreeSystem('cargo');
                if (!t) {
                    var cr = diveCrew_sidecar_1.diveCrew.findById(msg.crewId);
                    if (cr) {
                        // assert.notNil(cr)
                        diveCrew_sidecar_1.diveCrew.say(cr, 'No room to buy this!');
                    }
                    // console.log('could not find location!')
                }
                if (t) {
                    voyageMessageMoney_sidecar_1.voyageMessageMoney.sendMessageAndImmediatelyExecute({
                        money: status_1.money - msg.cost,
                    });
                    voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
                        command: voyageMessageCrewCarry_1.EVoyageCrewCarryCommand.Create,
                        type: msg.itemType,
                        carryId1: common_1.createId(),
                        carryId2: 0,
                        crewId: 0,
                        i: t.i,
                        j: t.j,
                    });
                }
            }
        }
    }
}
exports.process = process;
function sendMessageRequest(msg) {
    websockets_sidecar_1.websockets._sendMessageRequest(write, msg);
}
exports.sendMessageRequest = sendMessageRequest;
